import { useEffect, useRef } from 'react';

/** Subtle idle bob for the workflow ghost cursor. */
export default function useGhostCursorFloat(size, padding = 0) {
  const ref = useRef(null);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    let raf;
    const loop = () => {
      const el = ref.current;
      if (el) {
        const t = performance.now() / 1000;
        const wx = Math.sin(t * 0.9) * 4 + Math.sin(t * 0.31 + 1.2) * 2;
        const wy = Math.cos(t * 0.7) * 3 + Math.cos(t * 0.22 + 0.5) * 2;
        el.style.transformOrigin = `${padding + size / 2}px ${padding + size - 4}px`;
        el.style.transform = `translate(${wx}px, ${wy}px)`;
      }
      raf = requestAnimationFrame(loop);
    };

    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, [padding, size]);

  return ref;
}
